"use client";

import { ErrorMessage } from "@/components/ui/error-message";
import logger from "@/libs/utils/logging/logger";
import { useEffect } from "react";

interface RouteErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

// Fallback for the route error boundaries (error.tsx). A full reload re-runs the proxy and every
// server fetch, which is what recovers from a backend outage — reset() alone would replay the error.
export function RouteError({ error }: RouteErrorProps) {
  useEffect(() => {
    logger.error({ err: error, digest: error.digest }, "Route error boundary caught an error");
  }, [error]);

  return (
    <div role="alert" className="flex min-h-[60vh] items-center justify-center">
      <ErrorMessage
        fill={false}
        heading="We're having trouble loading this page"
        message="This is usually temporary. Try again in a moment, and contact support if it keeps happening."
        onRetry={() => window.location.reload()}
      />
    </div>
  );
}
